import { gql } from '@apollo/client';
/**
 * @fragment SaleItemListLightFragment
 * @since 1.0.0
 */
export const SaleItemListLightFragment = gql `
  fragment SaleItemListLightFragment on SaleItem {
    id
    sku
    title
    active
    optionConfiguration

    price

    group {
      id
      title
    }

    partners {
      id
      name
    }
  }
`;
